<template>
  <tr
    :class="{
      'so-summary-table__row--highlighted': item.highlighted,
      'so-summary-table__row--summary': summary,
      'so-summary-table__row--item td': !summary,
    }"
    class="so-summary-table__row"
    data-testid="so-summary-table-row"
  >
    <td class="so-summary-table__title">
      <span>{{ item.title }}</span>
    </td>
    <td class="so-summary-table__value">
      <span v-if="isEmpty">
        {{ item.fallbackValue || "-" }}
      </span>
      <span v-else-if="item.type === SoSummaryTableValueType.MONEY">
        {{ formatMoney({ amount: item.value as number }) }}
      </span>
      <span
        v-else-if="item.type === SoSummaryTableValueType.MONEY_COLORED"
        :class="{
          'text-danger': (item.value as number) > 0,
          'text-success': (item.value as number) < 0,
        }"
      >
        {{
          formatMoney({ amount: item.value as number, showNegativeSign: false })
        }}
      </span>
      <span
        v-else-if="item.type === SoSummaryTableValueType.BALANCE"
        :class="{
          'text-danger': (item.value as number) > 0,
          'text-success': (item.value as number) < 0,
        }"
      >
        {{ formatBalance(item.value as number) }}
      </span>
      <span v-else-if="item.type === SoSummaryTableValueType.DATE">
        {{ formatDate(item.value as Dayjs) }}
      </span>
      <span v-else-if="item.type === SoSummaryTableValueType.STATUS">
        <SoStatus :status="item.value as Status" />
      </span>
      <span v-else :title="item.value as string">
        {{ item.value }}
      </span>
      <span v-if="!isEmpty && item.append">{{ item.append }}</span>
    </td>
  </tr>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import {
    SoSummaryTableItem,
    SoSummaryTableValueType,
  } from "@/types/components/SoSummaryTable"
  import { formatBalance, formatMoney } from "@/helpers/moneyHelpers"
  import { formatDate } from "@/helpers/dateHelper"
  import { Dayjs } from "dayjs"
  import SoStatus from "./SoStatus.vue"
  import { Status } from "@/types/Status"

  export default defineComponent({
    components: { SoStatus },
    inheritAttrs: false,
    props: {
      item: {
        type: Object as PropType<SoSummaryTableItem>,
        required: true,
      },
      summary: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        SoSummaryTableValueType,
        Status,
        Dayjs,
        formatMoney,
        formatBalance,
        formatDate,
      }
    },
    computed: {
      isEmpty() {
        return !this.item.value && this.item.value !== 0
      },
    },
  })
</script>

<style scoped>
  .so-summary-table__row td {
    padding: 0.5rem 0;
  }
  .so-summary-table__row--item:not(:last-of-type) td {
    border-bottom: 1px solid rgb(var(--v-theme-border));
  }
  .so-summary-table__row--highlighted {
    background-color: rgb(var(--v-theme-surface-dim));
  }
  .so-summary-table__value {
    text-align: right;
    white-space: pre;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .so-summary-table__row--summary td {
    border-top: 1px solid rgb(var(--v-theme-on-surface));
  }
  .so-summary-table__row--summary td > span {
    font-weight: 500;
    font-size: var(--theme-h5);
  }
</style>
